import styled from '@emotion/styled';

export const Container = styled.section`
  display: grid;
  display: -ms-grid;
  grid-template-rows: auto;
  -ms-grid-rows: auto;
  grid-template-columns: calc(50% - 8px) calc(50% - 8px);
  -ms-grid-columns: calc(50% - 8px) 16px calc(50% - 8px);
  grid-column-gap: 16px;
  align-items: center;

  padding: 48px 0;
  width: 100%;

  > div:first-of-type {
    -ms-grid-row: 1;
    -ms-grid-column: 1;
  }

  > div:last-of-type {
    -ms-grid-row: 1;
    -ms-grid-column: 3;
  }

  @media (max-width: 780px) {
    display: flex;
    flex-direction: column;
  }
`;

export const Post = styled.div`
  transition: all 200ms;
  place-self: stretch;
  background-color: ${({ theme }) => theme.colors.postnav.background};
  border: 1px solid ${({ theme }) => theme.colors.postnav.outline};
  border-radius: 3px;
  box-shadow: 0 3px 8px 0 rgba(116,129,141,.5);

  a {
    display: flex;
    text-decoration: none;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    padding: 16px;

    svg {
      flex: 0 0 auto;
      width: 25px;
      height: 25px;
      color: ${({ theme }) => theme.colors.postnav.link};

      ${({ isLeft }) => (isLeft ? 'margin-right: 16px' : 'margin-left: 16px')};
    }

    div {
      flex: 1 1;
    }

    p {
      letter-spacing: 0.142em;
      text-transform: uppercase;
      font-size: 12px;
      margin: 0;
      color: ${({ theme }) => theme.colors.postnav.title};

      ${({ isLeft }) => (isLeft ? 'text-align: right' : 'text-align: left')};
    }

    h3 {
      color: ${({ theme }) => theme.colors.postnav.link};
      border: none;
      margin: 0;
      padding: 0;
      font-weight: normal;
      font-size: 16px;

      ${({ isLeft }) => (isLeft ? 'text-align: right' : 'text-align: left')};
    }
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.postnav.backgroundActive};

    a svg {
      color: ${({ theme }) => theme.colors.postnav.linkActive};
    }

    a h3 {
      color: ${({ theme }) => theme.colors.postnav.linkActive};
    }
  }

  @media (max-width: 780px) {
    width: 100%;
    ${({ isLeft }) => isLeft && 'margin-bottom: 16px'};
  }
`;
